var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"slice-image-accent-square w-1x2 md_w-3x12 relative",class:_vm.margin},[_c('image-video-clip',{staticClass:"pb-ar-1x1 bg-gray-100",attrs:{"media":_vm.slice.image[0],"bg":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }